
$(function () {
    $('input[name="SendToSelfUrlDownloadPassword"]').on('change, focusout', function () {

        var $elem = $(this);
        var password = $elem.val();
        var isValid = $elem.valid();

        $('[id^=error_SendToSelfUrlDownloadPassword_]').hide();
        $('#AcceptTerms').prop('disabled', false);

        if (isValid) {
            $.ajax({
                url: '/selftoself-password-validation',
                type: 'POST',
                data: { 'password': password },
                success: function (result) {
                    if (result.WasValidated) {
                        if (result.IsInvalid) {
                            $elem.addClass('is-invalid');
                            $elem.removeClass('is-valid');
                            $('#AcceptTerms').prop('disabled', true);

                            $.each(result.Problems, function (index, problem) {
                                $('#error_SendToSelfUrlDownloadPassword_' + problem).show();
                            });
                        } else {
                            $elem.addClass('is-valid');
                            $elem.removeClass('is-invalid');
                        }
                    } else {
                        if (result.ErrorMessage) {
                            console.error(result.ErrorMessage);
                        }
                    }
                }
            });
        }
    });
});
